import { render, staticRenderFns } from "./DatabaseModalPanel.vue?vue&type=template&id=74000842&scoped=true"
import script from "./DatabaseModalPanel.vue?vue&type=script&lang=js"
export * from "./DatabaseModalPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74000842",
  null
  
)

export default component.exports